import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/home/Features';
import Testimonials from '../components/home/Testimonials';
import PartnersSection from '../components/PartnersSection';

const Home = () => {
  return (
    <div className="overflow-x-hidden">
      <div className="max-w-[2000px] mx-auto">
        <Hero />
        <Features />
        <Testimonials />
        <PartnersSection />
      </div>
    </div>
  );
};

export default Home; 